(function (w, d) {
  'use strict';

  var current = d.currentScript;
  if (!current) return;
  var ES = w.ES || {};

  var assets = {
    optionSelectionJs: current.getAttribute('data-option-selection-js') || '',
    quickviewJs: current.getAttribute('data-quickview-js') || '',
    quickviewLensJs: current.getAttribute('data-quickview-lens-js') || '',
    quickviewCss: current.getAttribute('data-quickview-css') || '',
    lensbuilderJs: current.getAttribute('data-lensbuilder-js') || '',
    lensbuilderCss: current.getAttribute('data-lensbuilder-css') || ''
  };
  w.__ES_QUICKVIEW_LAZY_ASSETS = Object.assign({}, w.__ES_QUICKVIEW_LAZY_ASSETS || {}, assets);
  w.__ES_LENSBUILDER_ASSETS = Object.assign({}, w.__ES_LENSBUILDER_ASSETS || {}, {
    lensbuilderJs: assets.lensbuilderJs || (w.__ES_LENSBUILDER_ASSETS || {}).lensbuilderJs || '',
    lensbuilderCss: assets.lensbuilderCss || (w.__ES_LENSBUILDER_ASSETS || {}).lensbuilderCss || ''
  });

  if (w.__esQuickviewLoaderBootstrapBooted) return;
  w.__esQuickviewLoaderBootstrapBooted = true;

  var loaderSrc = current.getAttribute('data-loader-src') || '';
  var requested = false;
  var pending = null;

  function report(message, error) {
    if (ES.warn) {
      ES.warn('quickview-bootstrap', message, error);
      return;
    }
    if (!(w.Shopify && w.Shopify.designMode)) return;
    try { if (w.console && typeof w.console.warn === 'function') w.console.warn('[EYESHELLS][Quick View] ' + message, error || ''); }
    catch (_reportError) {}
  }

  function allowed() {
    try {
      if (ES.media && typeof ES.media.quickViewAllowed === 'function') return ES.media.quickViewAllowed();
      return typeof w.ES_quickViewAllowed === 'function' && w.ES_quickViewAllowed();
    } catch (error) { report('Capability check failed.', error); return false; }
  }

  function triggerFor(event) {
    try { return event && event.target && event.target.closest ? event.target.closest('.engoj_btn_quickview') : null; }
    catch (error) { report('Could not resolve the Quick View trigger.', error); return null; }
  }

  function fallback(trigger) {
    try {
      var href = trigger && trigger.getAttribute ? trigger.getAttribute('href') : '';
      if (href && href !== '#' && !/^javascript:/i.test(href)) w.location.href = href;
    } catch (error) { report('Product-page fallback failed.', error); }
  }

  function unbind() {
    d.removeEventListener('pointerover', onIntent, true);
    d.removeEventListener('focusin', onIntent, true);
    d.removeEventListener('click', onIntent, true);
  }

  function replay(item) {
    if (!item || !item.trigger || !d.documentElement.contains(item.trigger) || !allowed()) return;
    if (item.type === 'click') { item.trigger.click(); return; }
    try { item.trigger.dispatchEvent(new Event(item.type, { bubbles: true })); }
    catch (error) { report('Could not replay Quick View intent.', error); }
  }

  function onLoaded(result) {
    if (!result) return false;
    var replayItem = pending;
    pending = null;
    unbind();
    replay(replayItem);
    return true;
  }

  function onFailed(error) {
    var failedItem = pending;
    pending = null;
    requested = false;
    report('Lazy loader failed to load.', error);
    if (failedItem && failedItem.type === 'click') fallback(failedItem.trigger);
  }

  function requestLoader(item) {
    pending = item || pending;
    if (requested || !allowed()) return;
    if (!loaderSrc) {
      report('Lazy-loader URL is missing.');
      if (pending && pending.type === 'click') fallback(pending.trigger);
      pending = null;
      return;
    }

    requested = true;
    if (ES.loader && ES.loader.script) {
      ES.loader.script('quickview:lazy-loader', loaderSrc, {
        async: true,
        reject: true,
        selector: 'script[data-es-quickview-lazy-loader]',
        attributes: { 'data-es-quickview-lazy-loader': '1' }
      }).then(onLoaded).catch(onFailed);
      return;
    }

    var script = d.createElement('script');
    script.src = loaderSrc;
    script.async = true;
    script.setAttribute('data-es-quickview-lazy-loader', '1');
    script.onload = function () { onLoaded(script); };
    script.onerror = function (error) {
      try { script.remove(); } catch (_removeError) {}
      onFailed(error);
    };
    (d.head || d.documentElement).appendChild(script);
  }

  function onIntent(event) {
    var trigger = triggerFor(event);
    if (!trigger || !allowed()) return;
    var type = event.type;
    if (type === 'click') {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    requestLoader({ trigger: trigger, type: type });
  }

  d.addEventListener('pointerover', onIntent, true);
  d.addEventListener('focusin', onIntent, true);
  d.addEventListener('click', onIntent, true);
})(window, document);
